"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitorManagement = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
require("./visitorManagement.tmpl.less");
const m = require("../SynView");
class visitorManagement extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-users";
        this.m_hasMenu = false;
        this.m_fullscreen = true;
        this.m_idleTimeoutPaused = false;
    }
    renderContents() {
        let that = this;
        that.m_$wizardPane = that.m_$container.find("#synWizardPane");
        that.initWizardAsync();
    }
    activate() {
        let that = this;
        super.activate();
        let idleTimeoutMs = Utilities_1.synUtil.Configs.getValue("visitormanagement.terminalidletimeout", "");
        if (sessionStorage.getItem("visitorManagement.terminal") === "true" && idleTimeoutMs !== "") {
            let intIdleTimeoutMs = parseInt(idleTimeoutMs, 10);
            that.m_idleTimeoutRestMs = intIdleTimeoutMs;
            let idleTimeoutHandle = function () {
                if (that.m_idleTimeoutRestMs <= 0) {
                    clearInterval(that.m_idleTimeoutTimer);
                    that.m_$wizardPane.trigger("synWizardCancel");
                }
                else {
                    if (!that.m_idleTimeoutPaused) {
                        let elapsedTime = Date.now() - that.m_idleTimeoutLastDate;
                        that.m_idleTimeoutRestMs -= elapsedTime;
                        that.m_idleTimeoutLastDate = Date.now();
                    }
                }
            };
            setTimeout(() => {
                that.m_idleTimeoutLastDate = Date.now();
                window.setInterval(idleTimeoutHandle, 200);
                that.m_$wizardPane.mousemove(function (e) {
                    that.m_idleTimeoutRestMs = intIdleTimeoutMs;
                });
                that.m_$wizardPane.keypress(function (e) {
                    that.m_idleTimeoutRestMs = intIdleTimeoutMs;
                });
            }, 0);
        }
    }
    deactivate() {
        let that = this;
        super.deactivate();
        // Pause the idleTimeout if exists
        let idleTimeoutMs = Utilities_1.synUtil.Configs.getValue("visitormanagement.terminalidletimeout", "");
        if (idleTimeoutMs !== "" && that.m_idleTimeoutTimer) {
            clearInterval(that.m_idleTimeoutTimer);
            that.m_idleTimeoutTimer;
            that.m_idleTimeoutRestMs = parseInt(idleTimeoutMs);
            that.m_$wizardPane.off("mousemove");
            that.m_$wizardPane.off("keypress");
        }
    }
    pauseIdleTimeout(pause = true) {
        let that = this;
        if (pause)
            that.m_idleTimeoutPaused = true;
        else
            that.m_idleTimeoutPaused = false;
    }
    forceRefresh(modificationInfo) { }
    //#endregion Inherited from SynView
    //#region Helpers
    initWizardAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let checklist = require("./wizardSteps/checklist");
            let checklistStep = checklist.step;
            let briefing = require("./wizardSteps/briefing");
            let briefingStep = briefing.step;
            let questionnaire = require("./wizardSteps/questionnaire");
            let questionnaireStep = questionnaire.step;
            let end = require("./wizardSteps/end");
            let endStep = end.step;
            let wizardOptions = {
                WizardName: "visitormanagement",
                WizardSteps: [checklistStep, briefingStep, questionnaireStep, endStep],
            };
            const terminalMode = sessionStorage.getItem("visitorManagement.terminal") === "true";
            const locationId = sessionStorage.getItem("visitorManagement.locationId");
            let languageSelectionUrl = tdBasePath + "/VisitorManagement.html";
            let queryParams = {};
            if (terminalMode) {
                queryParams["terminal"] = "true";
                let endTimeoutMs = Utilities_1.synUtil.Configs.getValue("visitormanagement.terminalendtimeout", "");
                if (endTimeoutMs !== "")
                    wizardOptions.EndTimeoutMS = parseInt(endTimeoutMs, 10);
            }
            if (locationId)
                queryParams["locationId"] = locationId;
            if (Object.keys(queryParams).length)
                languageSelectionUrl += "?" + Object.keys(queryParams)
                    .map((d) => d + "=" + encodeURIComponent(queryParams[d]))
                    .join("&");
            yield that.m_$wizardPane.synWizard(wizardOptions);
            that.m_$wizardPane.on("synWizardCancel", (e) => {
                that.m_$wizardPane.synWizard("cleanup", false).then(() => {
                    Cookies.remove("oidc_lastprovider");
                    Cookies.remove("oidc_profile");
                    Utilities_1.synUtil.logout(true, languageSelectionUrl);
                });
            });
            that.m_$wizardPane.on("synWizardFinish", (e) => {
                Cookies.remove("oidc_lastprovider");
                Cookies.remove("oidc_profile");
                Utilities_1.synUtil.logout(true, languageSelectionUrl);
            });
            that.m_$wizardPane.on("synWizardPauseIdleTimeout", (e) => {
                that.pauseIdleTimeout(true);
            });
            that.m_$wizardPane.on("synWizardUnpauseIdleTimeout", (e) => {
                that.m_idleTimeoutLastDate = Date.now();
                that.pauseIdleTimeout(false);
            });
        });
    }
}
exports.visitorManagement = visitorManagement;
